
  import {Component, Vue} from 'vue-property-decorator';
  import {IReport} from "@/modules/Report/interfaces/report.interface";
  import ReportTable from "@/modules/Report/components/ReportTable.vue";
  import {ReportPrintActions} from "@/modules/Report/mixins/print-data.mixin";
  import _ from "lodash";
  import {IBook} from "@/interfaces/book.interface";
  import {IApp} from "@/interfaces/app.interface";

  @Component({
    components: {
      ReportTable,
    },
  })
  export default class ReportTableBalance extends Vue {

    get tableList(): IReport.IBalanceItem[] { return this.$store.getters['report/sortedList'].array; }
    get dataProps() {
      return [
        { label: 'Код',                prop: 'id',          propType: IApp.SortingPropType.String, mobileHide: true, },
        { label: 'Корпорация',         prop: 'corpName',    propType: IApp.SortingPropType.String, actionClick: this.openDetails },
        { label: 'Начальное сальдо',   prop: 'saldoBeg',    propType: IApp.SortingPropType.Number, isMoney: true, },
        { label: 'Начисление',         prop: 'sale',        propType: IApp.SortingPropType.Number, isMoney: true, },
        { label: 'Паркомат',           prop: 'payCard',     propType: IApp.SortingPropType.Number, isMoney: true, },
        { label: 'Эквайринг',          prop: 'payEqv',      propType: IApp.SortingPropType.Number, isMoney: true, },
        { label: 'Банк',               prop: 'payBank',     propType: IApp.SortingPropType.Number, isMoney: true, },
        { label: 'Последняя оплата',   prop: 'lastDatePay', propType: IApp.SortingPropType.Date, dateFormat: 'DD.MM.YYYY', mobileHide: true, },
        { label: 'Кол-во машин',       prop: 'carCnt',      propType: IApp.SortingPropType.Number, mobileHide: true, },
        { label: 'Конечное сальдо',    prop: 'saldoEnd',    propType: IApp.SortingPropType.Number, isMoney: true, },
        { label: 'Машин в корпорации', prop: 'corpCarCnt',  propType: IApp.SortingPropType.Number, mobileHide: true, },
        { label: 'Последняя парковка', prop: 'lastSale',    propType: IApp.SortingPropType.Date, dateFormat: 'DD.MM.YYYY', mobileHide: true, },
        { label: 'Тип оплаты',         prop: 'corpPayType', propType: IApp.SortingPropType.String, mobileHide: true, },
        {
          label: 'Действия',
          prop: 'actions',
          propType: IApp.SortingPropType.Actions,
          actions: [
            { tooltip: 'Детально', icon: 'list', actionClick: this.openDetails, },
          ],
        }
      ];
    }
    get printedOptions() {
      return {
        $options: this.$options,
        tableList: this.tableList,
        dataProps: this.dataProps,
      };
    }

    async reloadData() {
      await this.$store.dispatch('report/getReport', {
        reportName: this.$store.state.report.activeReport,
        filters: {...this.$store.state.report.filters},
      });
    }

    printTable() {
      ReportPrintActions.PrintTable(this.printedOptions);
    }

    prepareExcel() {
      return ReportPrintActions.PrepareExcel(this.printedOptions);
    }

    async openDetails(rowItem: IReport.IBalanceItem) {
      let detailFilters: IReport.IFilters = {
        ...this.$store.state.report.filters,
        corpId: rowItem.id,
        str: '',
      };

      this.$store.commit('report/setProperty', { name: 'defaultFilters', value: _.cloneDeep(this.$store.state.report.filters) });
      this.$store.commit('report/setProperty', { name: 'filters', value: detailFilters });

      this.$store.commit('report/setProperty', { name: 'displayDetails', value: true });

      await this.$store.dispatch('book/getBook', { bookNames: [IBook.TableName.carBalanceTypes] });

      this.$store.commit('report/setProperty', {
        name: 'previousReport',
        value: {
          name: IReport.ReportName.Balance,
          list: this.$store.state.report.report,
        }
      });
      await this.$store.dispatch('report/getReport', { reportName: IReport.ReportName.CarsBalance, filters: detailFilters, });

    }
  }
